// extracted by mini-css-extract-plugin
export default {"root":"styles_root__ysGEo","container":"styles_container__BERHL","logo":"styles_logo__8RGug","content":"styles_content__S-1kg"};